import { TranslationKey } from '../../../../../types/translation/TranslationKey';
import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { CsvUploadType } from '../../../../../types/csvUploadConfiguration';
import CsvUploadConfigurationsScreen from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationsScreen';
import CsvUploadConfigurationUpdatePane from '../../../../components/CsvUploadConfiguration/CsvUploadConfigurationUpdatePane';
import { t } from '../../../../../types/translation/Translator';
import { Breadcrumbs, Crumb, UserSettingsCrumb } from '../../../../components/Breadcrumbs';
import { Routing } from '../../../../../util/routes.util';

export default function UserAdvancedSettingsPane() {
  const navigate = useNavigate();

  return (
    <div className='flex h-full flex-grow flex-col'>
      <Breadcrumbs>
        <UserSettingsCrumb />
        <Crumb
          current
          text={t(TranslationKey.settings).singular.upper}
          path={Routing.settings.users.advanced.importConfigurations.overview()}
        />
      </Breadcrumbs>
      <div className='content-y-breadcrumbs flex-grow flex-col'>
        {/* <Tabs>
          <Tab
            text={t(TranslationKey.importConfigurations).singular.label}
            path={'/settings/users/advanced/import_configurations'}
            key={'import_configurations'}
          />
        </Tabs> */}
        <Routes>
          <Route
            path={'import_configurations/*'}
            element={<CsvUploadConfigurationsScreen type={CsvUploadType.user} backPath='/settings/users' />}
          />
          <Route
            path={'import_configurations/update/:id/*'}
            element={
              <CsvUploadConfigurationUpdatePane
                type={CsvUploadType.user}
                onDone={() => navigate('import_configurations')}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
}
